import { defineMessages } from 'react-intl';

export const BITBUCKET_PR_VALUE_HEADING_LABEL =
	'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextBitbucket';
export const BITBUCKET_PR_VALUE_FEATURES_LABEL =
	'WacSignupForm.signupOfferingIncludesFeaturesFreeBitbucket';

export const bitbucketSignupPrValueMessages = defineMessages({
	heading: {
		id: 'BitbucketSignupPrValue.heading',
		defaultMessage: 'Ship better pull requests, faster',
	},
	aiPullRequestDescriptions: {
		id: 'BitbucketSignupPrValue.aiPullRequestDescriptions',
		defaultMessage: 'Draft clear pull request descriptions with AI',
	},
	codeReviewWorkflow: {
		id: 'BitbucketSignupPrValue.codeReviewWorkflow',
		defaultMessage: 'Review code and resolve feedback in one workflow',
	},
	jiraUpdates: {
		id: 'BitbucketSignupPrValue.jiraUpdates',
		defaultMessage: 'Keep Jira updated from branches, commits, and PRs',
	},
	builtInCiCd: {
		id: 'BitbucketSignupPrValue.builtInCiCd',
		defaultMessage: 'Secure, reliable CI/CD built in',
	},
});
